import { personaEnums } from '../../enums'
import { phoneNumbers } from './phoneNumbers'

const personas = {

  clearwaterProgram: {
    cta: 'Get Started',
    name: personaEnums.personas.PROGRAM_CLEARWATER,
    phoneNumber: phoneNumbers.umaClearwater,
  },

  currentStudent: {
    cta: 'Go to Login',
    ctaLink: 'https://pumaden.ultimatemedical.edu/',
    name: personaEnums.personas.CURRENT_STUDENT,
    phoneNumber: phoneNumbers.umaOnline,
  },

  onlineProgram: {
    cta: 'Get Started',
    name: personaEnums.personas.PROGRAM_ONLINE,
    phoneNumber: phoneNumbers.umaOnline,
  },

  umaAlumni: {
    cta: 'Connect',
    ctaLink: 'https://connectuma.com/',
    name: personaEnums.personas.ALUMNI,
    phoneNumber: phoneNumbers.umaAlumniPersona,
  },

  umaCareerServices: {
    cta: 'Get Started',
    name: personaEnums.personas.CAREER_SERVICES,
    phoneNumber: phoneNumbers.umaCareerServices,
  },

  umaClearwater: {
    cta: 'Get Started',
    name: personaEnums.personas.CAMPUS_CLEARWATER,
    phoneNumber: phoneNumbers.umaClearwater,
  },

  umaEmployer: {
    cta: 'Find Candidates',
    name: personaEnums.personas.EMPLOYER,
    phoneNumber: phoneNumbers.umaEmployerPersona,
  },

  umaOnline: {
    cta: 'Get Started',
    name: personaEnums.personas.CAMPUS_ONLINE,
    phoneNumber: phoneNumbers.umaOnline,
  },

  umaWorkHere: {
    cta: 'Job Board',
    ctaLink: 'https://careers-ultimatemedical.icims.com/',
    name: personaEnums.personas.WORK_HERE,
    phoneNumber: phoneNumbers.umaWorkHerePersona,
  },

}

export default personas
